import request from '@/utils/request'
const apiPath = '/tech/bigCustomerBoard/tee'

/**
 * 大客户（3.0 以上客户）交付看板（REQ-2026-107511）
 * 挂在教培看板下的两个页签：「3.0 交付周报」「3.0 客户明细」
 */
const bigCustomerBoardApi = {
  // 某月的周报：每个自然周一行 + 月合计行；month 形如 2026-09，空取当月
  weekly(month) {
    return request.get(`${apiPath}/weekly`, { params: { month } })
  },
  // 周报某一格点开：该周该指标对应的客户；metric 见 bigWeekly.vue 的 METRICS
  weekDetail(weekStart, metric) {
    return request.get(`${apiPath}/weekDetail`, { params: { weekStart, metric } })
  },
  // 全部大客户明细（含子账号），后端一次给全量，前端分页
  detail(keyword, range = {}) {
    return request.get(`${apiPath}/detail`, { params: { keyword, ...range } })
  },
  saveMeasure(weekStart, measure) {
    return request.post(`${apiPath}/measure`, { weekStart, measure })
  },
  exportWeekly(month) {
    return request.get(`${apiPath}/exportWeekly`, { params: { month } })
  },
  exportDetail(keyword, range = {}) {
    return request.get(`${apiPath}/exportDetail`, { params: { keyword, ...range } })
  }
}
export default bigCustomerBoardApi
